import { useState, useEffect } from "react";
import { Row, Col, Button, Form, Alert, ProgressBar, Card } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";

const HelpMatForm = (props) => {
  const [data, setData] = useState({ jcats: props.jcats, jobs: [], data: props.mode === 2 ? props.data : {} });
  const [adding, setAdding] = useState(false);
  const [jcat, setJCat] = useState(parseInt(data.data.job_category_id));
  const [jobing, setJobing] = useState(false);
  const fetchJobsByCat = () => {
    if (jcat > 0) {
      setJobing(true);
      axios
        .get(Utils.apiUrl(`users/fetchjobsbycat/${jcat}`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setData({ ...data, jobs: res.data.jobs });
          }
          setJobing(false);
        })
        .catch((err) => {
          setJobing(false);
          console.log(err);
        });
    } else {
      setData({ ...data, jobs: [] });
    }
  };

  useEffect(fetchJobsByCat, [jcat]);

  const saveData = (e) => {
    const frm = e.currentTarget;
    const postVars = new FormData(frm);

    e.preventDefault();

    if (frm.ftype.value === "upload") {
      var file = frm.fname.files[0];

      if (file.size >= _.get(process.env,'REACT_APP_MAX_FILE_SIZE',10) * 1024 * 1024) {
        alert(`Max file size ${_.get(process.env,'REACT_APP_MAX_FILE_SIZE',10)} MB`);
        return false;
      }

      var allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/csv",
        "text/plain",
      ];

      if (!allowedTypes.includes(file.type)) {
        alert("only (jpg, png, pdf, docx, xlsx, pptx, csv, txt) files are allowed, please select again!");
        return false;
      }
    }

    setAdding(true);

    if (props.mode === 2) {
      postVars.append("id", data.data.id);
    }

    axios
      .post(Utils.apiUrl("users/saveresource"), postVars, Utils.apiHeaders())
      .then((res) => {
        setAdding(false);
        props.afterSave(res.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Card className="my-3">
        <Card.Body>
          {adding && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">saving data..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {!adding && (
            <>
              <Form className="needs-validation" encType="multipart/form-data" novalidate onSubmit={saveData}>
                <Row>
                  <Col sm={12} className="mb-3">
                    <Form.Label>Help Material Title *</Form.Label>
                    <input
                      type="text"
                      required
                      name="title"
                      maxlength="255"
                      className="form-control"
                      placeholder="Help Material Title"
                      defaultValue={_.get(data, "data.title", "")}
                    />
                  </Col>
                  <Col sm={6} className="mb-3">
                    <Form.Label>Job Category *</Form.Label>
                    <select
                      name="job_category_id"
                      required
                      className="form-select"
                      onChange={(e) => setJCat(parseInt(e.currentTarget.value === "" ? 0 : e.currentTarget.value))}
                    >
                      <option value="" selected={jcat === 0}>
                        Select Job Category
                      </option>
                      {data.jcats.length > 0 &&
                        data.jcats.map((jc) => (
                          <option key={jc.id} value={jc.id} selected={jcat === parseInt(jc.id)}>
                            {jc.name}
                          </option>
                        ))}
                    </select>
                  </Col>
                  <Col sm={6} className="mb-3">
                    <Form.Label>Job *</Form.Label>
                    {jobing && (
                      <Alert variant="light" className="p-1 px-3">
                        Fetching Jobs..
                      </Alert>
                    )}

                    {!jobing && (
                      <select name="job_id" required className="form-select">
                        <option value="" selected={parseInt(data.data.job_id) === 0}>
                          Any Job
                        </option>
                        {data.jobs.length > 0 &&
                          data.jobs.map((j) => (
                            <option key={j.id} value={j.id} selected={parseInt(data.data.job_id) === parseInt(j.id)}>
                              {j.name}
                            </option>
                          ))}
                      </select>
                    )}
                  </Col>
                  <Col sm={6} className="mb-3">
                    <Form.Label>Media Type </Form.Label>
                    <select
                      name="ftype"
                      required
                      className="form-select"
                      onChange={(e) => setData({ ...data, data: { ...data.data, ftype: e.currentTarget.value } })}
                    >
                      <option value="upload" selected={_.get(data, "data.ftype", "upload") === "upload"}>
                        Upload
                      </option>
                      <option value="link" selected={_.get(data, "data.ftype", "upload") === "link"}>
                        Link
                      </option>
                      <option value="ext_link" selected={_.get(data, "data.ftype", "upload") === "ext_link"}>
                        External Link
                      </option>
                    </select>
                  </Col>
                  <Col sm={6} className="mb-3">
                    <Form.Label>{_.get(data, "data.ftype", "upload") == "upload" ? "Upload" : "Link"} *</Form.Label>
                    {_.get(data, "data.ftype", "upload") === "upload" && (
                      <>
                        <input
                          type="file"
                          required
                          class="form-control"
                          name="fname"
                          accept="image/jpg,image/jpeg,image/png,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/csv,text/plain"
                        />
                        <mark>Max File size {_.get(process.env,'REACT_APP_MAX_FILE_SIZE',10)}MB (jpg, png, pdf, docx, xlsx, pptx, csv, txt)</mark>
                      </>
                    )}
                    {_.get(data, "data.ftype", "upload") === "link" && (
                      <input type="text" class="form-control" name="fname" required placeholder="Enter embedded video link" value={data.data.fname} />
                    )}
                    {_.get(data, "data.ftype", "upload") === "ext_link" && (
                      <input type="text" class="form-control" name="fname" required placeholder="External link" value={data.data.fname} />
                    )}
                  </Col>
                  <Col sm={12} className="mb-3 text-end">
                    <Button type="submit" variant="primary" className="py-1 px-4">
                      Save {_.get(data, "data.type", "help") === "help" ? "Help Material" : "Resource"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default HelpMatForm;
